import { Link } from 'react-router';
import { useI18n } from '../lib/i18n';

export function NotFoundPage({ title, message }: { title?: string; message?: string }) {
  const { t } = useI18n();
  return (
    <main className="landing">
      <section className="hero">
        <h1>{title ?? t('page.not_found_title')}</h1>
        <p>{message ?? t('page.not_found_message')}</p>
        <Link to="/">{t('page.back_to_start')}</Link>
      </section>
    </main>
  );
}
